import React, { useEffect } from 'react';
import NavigationBar from './NavigationBar';
import { useTheme } from '../context/ThemeContext';

export default function Layout({ children }) {
    const { loadBranding } = useTheme();

    useEffect(() => {
        loadBranding();
    }, [loadBranding]);

    return (
        <div>
            <NavigationBar />
            <div className="layout-main">
                {children}
            </div>
        </div>
    );
}
